import React from 'react'
import Background from './Background'
import Loader from './Loader'

function CalendarLoader({ style }: ICalendarLoaderProps) {
  return (
    <Background style={style}>
      <Loader />
    </Background>
  )
}

export default CalendarLoader

export interface ICalendarLoaderProps {
  style?: React.CSSProperties
}
